import React from "react";
import RidWordmark from "../../components/RidWordmark";

const TopBarLeft = () => {
    return <div className="topbar-left">
        <div className="topbar-brand" data-testid="topbar-brand" aria-label="Retail ID">
            <div className="topbar-logo" aria-hidden>
                <img src="/images/rid-logo.svg" alt="Retail ID" className="logo-img" />
            </div>
            <div className="topbar-brand-title" aria-hidden>
                <RidWordmark title="Retail ID" />
            </div>
        </div>
    </div>
};

export default React.memo(TopBarLeft);